<template>
    <div>
        <dx-grid
            url="sywAccounts"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="bulkTransactionsDialog" max-width="1000">
            <v-card class="pa-3">
                <div class="headline mb-3">New Transaction</div>

                <v-layout row class="pa-0">
                    <v-flex xs6 class="mr-3">
                        <v-menu
                            v-model="bulkTransactions.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="bulkTransactions.date"
                                    :value="bulkTransactions.date"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="bulkTransactions.date"
                            ></v-date-picker>
                        </v-menu>
                        <v-select
                            v-model="bulkTransactions.type"
                            :items="['Debit', 'Credit']"
                            label="Type"
                        ></v-select>
                        <v-text-field
                            class="pt-2"
                            prepend-icon="mdi-currency-usd"
                            v-model="bulkTransactions.amount"
                            label="Amount"
                            type="number"
                            ref="amount"
                        ></v-text-field>
                        <v-text-field
                            class="pt-2"
                            v-model="bulkTransactions.description"
                            label="Description"
                        ></v-text-field>
                        <v-text-field
                            class="pt-2"
                            v-model="bulkTransactions.note"
                            label="Note"
                        ></v-text-field>
                        <v-text-field
                            class="pt-2"
                            v-model="bulkTransactions.year"
                            label="Year"
                        ></v-text-field>
                        <v-combobox
                            v-if="bulkTransactions.type == 'Credit'"
                            v-model="bulkTransactions.paymentType"
                            :items="paymentTypes"
                            label="Payment Type"
                        ></v-combobox>
                    </v-flex>

                    <v-flex xs6>
                        <div v-if="selected.length == 1">
                            <div class="font-weight-medium mb-1">Account</div>
                            <div
                                style="overflow-y: auto; height: 100px; border: #4caf50 2px solid;"
                                class="pt-2 px-2"
                            >
                                <div>{{ selected[0].name }}</div>
                                <div>{{ selected[0].homePhone }}</div>
                                <div>{{ selected[0].address }}</div>
                            </div>
                        </div>
                        <div
                            v-if="selected.length > 1"
                            class="font-weight-medium mb-2"
                        >
                            Accounts ({{ selected.length }})
                        </div>
                        <div
                            v-if="selected.length > 1"
                            style="overflow-y: auto; height: 410px; border: #4caf50 2px solid;"
                            class="pa-2 mb-2"
                        >
                            <div v-for="(account, index) in selected">
                                <v-layout row class="pa-0">{{
                                    account.name
                                }}</v-layout>
                                <v-divider
                                    class="my-1"
                                    v-if="index + 1 < selected.length"
                                ></v-divider>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>

                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeBulkTransactionsDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveBulkTransactions"
                        :loading="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="editAccountDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline mb-3" v-if="accountToEdit.id">
                    Update Account
                </div>
                <div class="headline mb-3" v-if="!accountToEdit.id">
                    New Account
                </div>

                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.firstName"
                    label="First Name"
                ></v-text-field>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.lastName"
                    label="Last Name"
                ></v-text-field>
                <v-layout row class="pa-0">
                    <v-text-field
                        class="pt-2 mr-2"
                        v-model="accountToEdit.firstNameEng"
                        label="First Name English"
                    ></v-text-field>
                    <v-text-field
                        class="pt-2"
                        v-model="accountToEdit.lastNameEng"
                        label="Last Name English"
                    ></v-text-field>
                </v-layout>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.address"
                    label="Address"
                ></v-text-field>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.homePhone"
                    label="Home Phone"
                ></v-text-field>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.cellphone"
                    label="Cellphone"
                ></v-text-field>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.cellphone2"
                    label="Wife Phone"
                ></v-text-field>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.email"
                    label="Email"
                ></v-text-field>
                <v-text-field
                    class="pt-2"
                    v-model="accountToEdit.familyGroup"
                    label="Family Group"
                ></v-text-field>

                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="editAccountDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveAccount"
                        :loading="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency, toISOLocal } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Accounts",

        selected: [],
        actions: [],

        processing: false,

        bulkTransactions: {
            type: "",
            date: toISOLocal(new Date(moment())).substr(0, 10),
            datePickerMenu: false,
            paymentType: "",
            description: "",
            note: "",
            amount: "",
            billingZipCode: "",
            cardNumber: "",
            expDate: "",
            cVV: "",
            year: "",
        },

        bulkTransactionsDialog: false,

        paymentTypes: ["Check", "Cash", "Credit Card"],

        accountToEdit: {
            id: "",
            firstName: "",
            lastName: "",
            firstNameEng: "",
            lastNameEng: "",
            address: "",
            homePhone: "",
            cellphone: "",
            cellphone2: "",
            email: "",
            familyGroup: "",
        },

        editAccountDialog: false,

        columns: [
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "English Name",
                field: "englishName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: false,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: "",
                selectedFilterOperation: null,
            },
            {
                label: "Family Group",
                field: "familyGroup",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellphone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Phone",
                field: "cellphone2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email",
                field: "email",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Billed",
                field: "billed",
                type: "number",
                visible: true,
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Paid",
                field: "paid",
                type: "number",
                visible: true,
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Balance",
                field: "balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Count",
                field: "transactionCount",
                type: "number",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Payment At",
                field: "lastPaymentAt",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.actions.push({
            text: "New Transaction",
            action: this.openBulkTransactionsDialog,
            showOnSelection: true,
        });

        this.actions.push({
            text: "New Account",
            action: this.addAccount,
            showOnSelection: false,
        });

        const response = await this.$http.get(
            "api/transactions/getCurrentYear"
        );

        this.bulkTransactions.year = response.year1;
    },
    methods: {
        async onRowClicked(row) {
            this.accountToEdit.id = row.id;
            this.accountToEdit.firstName = row.firstName;
            this.accountToEdit.lastName = row.lastName;
            this.accountToEdit.firstNameEng = row.firstNameEng;
            this.accountToEdit.lastNameEng = row.lastNameEng;
            this.accountToEdit.address = row.address;
            this.accountToEdit.homePhone = row.homePhone;
            this.accountToEdit.cellphone = row.cellphone;
            this.accountToEdit.cellphone2 = row.cellphone2;
            this.accountToEdit.email = row.email;
            this.accountToEdit.familyGroup = row.familyGroup;

            this.editAccountDialog = true;
        },
        addAccount() {
            this.accountToEdit = {
                id: "",
                firstName: "",
                lastName: "",
                firstNameEng: "",
                lastNameEng: "",
                address: "",
                homePhone: "",
                cellphone: "",
                cellphone2: "",
                email: "",
                familyGroup: "",
            };

            this.editAccountDialog = true;
        },
        openBulkTransactionsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.bulkTransactionsDialog = true;
        },
        closeBulkTransactionsDialog() {
            this.bulkTransactionsDialog = false;
        },
        async saveBulkTransactions() {
            try {
                this.processing = true;

                await this.$http.post("api/transactions/saveInBulk", {
                    accounts: this.selected.map((s) => s.id),
                    type: this.bulkTransactions.type,
                    date: moment(this.bulkTransactions.date).format(
                        "YYYY-MM-DD HH:mm:ss"
                    ),
                    paymentType: this.bulkTransactions.paymentType,
                    description: this.bulkTransactions.description,
                    note: this.bulkTransactions.note,
                    amount: this.bulkTransactions.amount,
                    billingZipCode: this.bulkTransactions.billingZipCode,
                    cardNumber: this.bulkTransactions.cardNumber,
                    expDate: this.bulkTransactions.expDate,
                    cVV: this.bulkTransactions.cVV,
                    year: this.bulkTransactions.year,
                });

                this.processing = false;
                this.bulkTransactionsDialog = false;

                this.$refs.grid.reloadGrid();
                this.$refs.grid.clearSelection();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveAccount() {
            try {
                this.processing = true;

                await this.$http.post("api/sywAccounts/save", {
                    id: this.accountToEdit.id ? this.accountToEdit.id : 0,
                    firstName: this.accountToEdit.firstName,
                    lastName: this.accountToEdit.lastName,
                    firstNameEng: this.accountToEdit.firstNameEng,
                    lastNameEng: this.accountToEdit.lastNameEng,
                    homePhone: this.accountToEdit.homePhone,
                    cellphone: this.accountToEdit.cellphone,
                    cellphone2: this.accountToEdit.cellphone2,
                    address: this.accountToEdit.address,
                    email: this.accountToEdit.email,
                    familyGroup: this.accountToEdit.familyGroup,
                });

                this.processing = false;
                this.editAccountDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
